module.exports = __webpack_public_path__ + "static/img/noimage.430c4fa.png";